// extracted by mini-css-extract-plugin
export default {"count":"CommentButton__count___BQy6u"};